import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../typings/theme';

export default makeStyles((theme: ITheme) => ({
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: '60%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logotypeImage: {
    width: 165,
    marginBottom: theme.spacing(4),
  },
  logotypeText: {
    color: 'white',
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down('sm')]: {
      fontSize: 48,
    },
  },
  subLogoTypeText: {
    color: 'white',
    fontWeight: 500,
    fontSize: 44,
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
    },
  },
  formContainer: {
    width: '40%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
  },
  form: {
    width: 320,
  },
  titleContainer: {
    width: 150,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 12px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  title: {
    fontSize: 18,
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  greeting: {
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(4),
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    marginBottom: -theme.spacing(2),
  },
  doneMessage: {
    marginTop: theme.spacing(2),
  },
  firstTextField: {
    marginTop: theme.spacing(4),
  },
  textFieldUnderline: {
    '&:before': {
      borderBottomColor: theme.palette.primary.light,
    },
    '&:after': {
      borderBottomColor: theme.palette.primary.main,
    },
    '&:hover:before': {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.default,
  },
  formButtons: {
    width: '100%',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  loginLoader: {
    marginLeft: theme.spacing(4),
  },
  copyright: {
    marginTop: theme.spacing(4),
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      bottom: theme.spacing(2),
    },
  },
  loginButton: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginTop: 50,
    fontSize: 16,
    textAlign: 'center',
    display: 'block',
  },
}));
